// extracted by mini-css-extract-plugin
export default {"main":"index_main__dZ6ii","mainArea":"index_mainArea__5PqlB","isMobile":"index_isMobile__FnVuk","operationArea":"index_operationArea__6Cdrp"};